import { render, staticRenderFns } from "./HumanCapitalWageAverageInput.vue?vue&type=template&id=01d00987&scoped=true&"
import script from "./HumanCapitalWageAverageInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalWageAverageInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalWageAverageInput.vue?vue&type=style&index=0&id=01d00987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d00987",
  null
  
)

export default component.exports